<template>
  <div class="object-vacancy-modal">
    <modal
      v-if="modalReady"
      :name="modalName"
      :adaptive="true"
      width="100%"
      height="100%"
      class="vacancy-modal-component"
      @before-open="togglePreventScroll(true)"
      @before-close="togglePreventScroll(false)"
    >
      <template slot="top-right">
        <button
          class="modal-close"
          type="button"
          data-ident="vacancyModalClose"
          @click="$modal.hide(modalName)"
        >
          <i
            class="icon"
          >
            <icon-times />
          </i>
        </button>
      </template>

      <flat-pickr-base
        v-model="opmMixin_fpModelValue"
        :inline="true"
        :viewed-date="opmMixin_objectViewedPickerDate"
        :month-count="calendarMonthCount"
        :vacancy-data="pickerVacancyData"
        :extended-input-emit="true"
        :month-navigation="true"
        @on-view-change="$store.commit('SET_OBJECT_PICKER_VIEWED_DATE', $event)"
        @on-ready="initModal($modal)"
      />

      <select-persons
        v-model="opmMixin_selectedPersons"
        :value="opmMixin_selectedPersons"
        :persons-max="objectData.personsMax"
      />
      <div class="row justify-content-center">
        <div class="col-12 col-sm-9 col-md-6">
          <button
            class="btn btn-primary btn-block mt-3 mb-2"
            type="button"
            :data-ident="`modal${modalName}Close`"
            @click="$modal.hide(modalName)"
          >
            <i class="icon"><icon-check /></i>
            {{ $t('common:button.picker_modal_submit') }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import FlatPickrBase from 'components/FlatPickrBase.vue';
import SelectPersons from 'components/SelectPersons.vue';
import ObjectPriceModels from 'mixins/ObjectPriceModels';
import ActiveObjectStore from 'mixins/ActiveObjectStore';

/* ICONS */
import IconCheck from 'ICON:IconCheck';
import IconTimes from 'ICON:IconTimes';

import {
  install, deinstall, isMobile, calendarMonthCount, modalName,
  modalLogic,
} from 'mixins/composition/PickerModal';
import { onMounted, onUnmounted } from '@vue/composition-api';

/**
 * @@author        j0Shi
 * @@date          2019.09.24
 * @@desc          Mobile modal to pick the calendar date
 * @@usedby        Object -> ObjectBookingBand
 */
export default {
  name: 'ObjectVacancyModal',
  components: {
    FlatPickrBase,
    SelectPersons,
    IconCheck,
    IconTimes,
  },
  mixins: [
    // v-models for picker and persons input
    ObjectPriceModels,
    // active object store helper
    ActiveObjectStore,
  ],
  props: {
    // vacancy data for the picker
    pickerVacancyData: {
      type: Object,
      default: () => ({
        count: 0,
        days: {},
        maxDate: new Date(),
      }),
    },
  },
  setup() {
    onMounted(() => {
      install();
    });

    onUnmounted(() => {
      deinstall();
    });

    const {
      modalReady, openModal, initModal, togglePreventScroll,
    } = modalLogic();

    return {
      isMobile,
      calendarMonthCount,
      modalName,
      modalReady,
      openModal,
      initModal,
      togglePreventScroll,
    };
  },
  watch: {
    isMobile: 'closeOnBreakpoint',
    // this is a little bit of a crook
    // since the modal itself doesn't fire a on-ready event or similar, we have to wait nextTick to init
    // it would be much better to actuaqlly wait for the modal to init and then fire the initModal function
    modalReady(value) {
      if (value) {
        this.$nextTick(() => {
          this.initModal(this.$modal);
        });
      }
    },
  },
  created() {
    // listen to store action for opening the pickr from other component
    this.$store.subscribeAction((action) => {
      if (action.type === 'OPEN_MODAL_PICKR' && action.payload === true) {
        this.openModal(this.$modal);
      }
    });
  },
  beforeDestroy() {
    this.togglePreventScroll(false);
  },
  methods: {
    // @vuese
    // closes the modal when we hit desktop view
    // this shouldn't happen too often in production as the user normally doesn't resize
    closeOnBreakpoint(newValue) {
      if (!newValue) this.$modal.hide('object-vacancy-modal');
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'scss/components/flatpickr-modal.scss';

.object-vacancy-modal {
  /deep/ .vacancy-modal-component{
    z-index: 2003; // booking band has 2002;
  }
}
</style>
